import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import Input from 'src/components/Input/Input';
import { RadioGroup, RadioGroupItem } from 'src/components/ui/radio-group';

export const EditZohoEmailApiDetailsSettings = ({ integration }) => {
  const { control, watch } = useFormContext();
  const integrationMethod = watch('integration_method');
  return (
    <div className={'w-full flex flex-col gap-2.5 p-2.5 bg-[#A498FF1A] rounded-sm-5'}>
      <div>
        <Controller
          control={control}
          name="client_id"
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <Input
              type={'text'}
              label={'Client ID'}
              placeholder={'7002.3400edkks11ff626343a98234a9ea6ad9'}
              invalidMessage={error?.message}
              value={value}
              isValid={!error?.message}
              onChange={onChange}
            />
          )}
        />
      </div>
      <div className={'content'}>
        <Controller
          control={control}
          name="client_secret"
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <Input
              type={'password'}
              label={'Client secret'}
              placeholder={'h899001.fhidjkkd.3728dj2664aas3637090211284hdjn5vs3kk220032'}
              invalidMessage={error?.message}
              value={value}
              isValid={!error?.message}
              onChange={onChange}
            />
          )}
        />
      </div>
      <div>
        <Controller
          control={control}
          name="scope"
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <Input
              type={'text'}
              label={'Scope'}
              placeholder={'Desk.tickets.ALL,Desk.basic.READ'}
              invalidMessage={error?.message}
              value={value}
              isValid={!error?.message}
              onChange={onChange}
            />
          )}
        />
      </div>
      <div>
        <Controller
          control={control}
          name="server_locale"
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <Input
              type={'text'}
              label={'Server locale'}
              placeholder={'com'}
              invalidMessage={error?.message}
              value={value}
              isValid={!error?.message}
              onChange={onChange}
            />
          )}
        />
      </div>
      <div className={'content'}>
        <Controller
          control={control}
          name="integration_method"
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <RadioGroup
              onChange={onChange}
              onValueChange={onChange}
              defaultValue={value}
              className="flex flex-row mt-5 mb-2.5 gap-5"
            >
              <div className={'flex items-center gap-2'}>
                <RadioGroupItem value={'code'} id="code" />
                <label htmlFor="code" className="cursor-pointer">
                  <p className="font-medium text-base text-ebony opacity-70 hover:opacity-100 transition">
                    Code
                  </p>
                </label>
              </div>
              <div className={'flex items-center gap-2'}>
                <RadioGroupItem value={'token'} id="token" />
                <label htmlFor="token" className="cursor-pointer">
                  <p className="font-medium text-base text-ebony opacity-70 hover:opacity-100 transition">
                    Token
                  </p>
                </label>
              </div>
            </RadioGroup>
          )}
        />
      </div>
      {integrationMethod === 'code' && (
        <div>
          <Controller
            control={control}
            name="code"
            render={({ field: { onChange, value }, fieldState: { error } }) => (
              <Input
                type={'text'}
                label={'Code'}
                placeholder={
                  '1453.1308edkks30cc626343a98234d9ea6ad9.be9736d58da9bamllddbbc8f68a3f4ff00'
                }
                invalidMessage={error?.message}
                value={value}
                isValid={!error?.message}
                onChange={onChange}
              />
            )}
          />
        </div>
      )}
      {integrationMethod === 'token' && (
        <div>
          <Controller
            control={control}
            name="refresh_token"
            render={({ field: { onChange, value }, fieldState: { error } }) => (
              <Input
                type={'text'}
                label={'Refresh Token'}
                placeholder={
                  '1000.8bfe42342affd5435478dc30b9036009.4239d1aab6e4f32b071224a313068b37'
                }
                invalidMessage={error?.message}
                value={value}
                isValid={!error?.message}
                onChange={onChange}
              />
            )}
          />
        </div>
      )}
    </div>
  );
};
